module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.tournament && _vm.tournament.flights && _vm.tournament.flights.length > 0) ? _c('div', _vm._l((_vm.tournament.flights), function(flight) {
    return _c('div', {
      key: flight.id,
      staticClass: "scrollable"
    }, [_c('FlightDiagram', {
      attrs: {
        "flight": flight,
        "tournament": _vm.tournament
      }
    }), _vm._v(" "), _c('p'), _vm._v(" "), _c('md-divider'), _vm._v(" "), _c('p')], 1)
  })) : _c('div', [_c('md-empty-state', {
    attrs: {
      "md-icon": "remove_circle",
      "md-label": "There are currently no flights for this tournament"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19478cdc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tournamentComponents/tournamentFlights.vue
// module id = 437
// module chunks = 1